import axios from 'axios'

const BASE_URL = process.env.VUE_APP_API_BASE_URL
const API_URL = BASE_URL + 'shop'
class ShopService {
  getShopList () {
    return axios.get(API_URL + '/list', { showLoader: false })
  }

  getShopById (id) {
    return axios.get(API_URL + '/' + id)
  }

  getShopByUrlAlias (urlAlias) {
    return axios.get(API_URL + '/url-alias/' + urlAlias)
  }

  createOrUpdate (shop) {
    return axios.post(API_URL, shop)
  }

  changeShopStatus (ShopId, ActiveStatus) {
    return axios.post(API_URL + '/' + ShopId + '/change-status/' + ActiveStatus, null)
  }
}

export default new ShopService()
